
define('template!ordersDetailOrderProductAlternativesItemView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="alt-card';
 if (!direct) { ;
__p += ' alt-indirect';
 } ;
__p += '">\n    <div class="alt-left">\n        <div class="alt-image">\n            ';
 if (imageUrl) { ;
__p += '\n                <a href="#pim/products/' +
((__t = ( productId )) == null ? '' : __t) +
'">\n                    <img src="' +
((__t = ( imageUrl )) == null ? '' : __t) +
'" />\n                </a>\n            ';
 } else { ;
__p += '\n                <div class="alt-image-placeholder">\n                    <i class="mdi-image-photo-camera"></i>\n                </div>\n            ';
 } ;
__p += '\n        </div>\n        <div class="alt-info">\n            <div class="alt-code">\n                <a href="#pim/products/' +
((__t = ( productId )) == null ? '' : __t) +
'">' +
((__t = ( productCode )) == null ? '' : __t) +
'</a>\n                ';
 if (!direct) { ;
__p += '\n                    <span class="alt-indirect-badge">' +
((__t = ( _.i18n('product.indirect') )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n            </div>\n            <div class="alt-name">' +
((__t = ( productName )) == null ? '' : __t) +
'</div>\n            ';
 if (supplierName) { ;
__p += '\n                <div class="alt-supplier">' +
((__t = ( supplierName )) == null ? '' : __t) +
'</div>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n    <div class="alt-config">\n        <div class="alt-options-selects"></div>\n        <div class="alt-print-select"></div>\n    </div>\n    <div class="alt-metrics">\n        <div class="alt-metric alt-stock">\n            <div class="metric-label">' +
((__t = ( _.i18n('common.stock') )) == null ? '' : __t) +
'</div>\n            <div class="stock-loading metric-loading"><i class="mdi-action-autorenew icon-spin"></i></div>\n            <div class="stock-value metric-value"></div>\n        </div>\n        <div class="alt-metric alt-price">\n            <div class="metric-label">' +
((__t = ( _.i18n('common.total') )) == null ? '' : __t) +
'</div>\n            <div class="price-loading metric-loading"><i class="mdi-action-autorenew icon-spin"></i></div>\n            <div class="price-value metric-value"></div>\n        </div>\n    </div>\n    <div class="alt-actions">\n        <button class="btn btn-sm js-create-offer" title="' +
((__t = ( _.i18n('product.createOfferFromAlternative') )) == null ? '' : __t) +
'">\n            <i class="mdi-content-add"></i>\n        </button>\n        <button class="btn btn-sm js-replace-product" title="' +
((__t = ( _.i18n('product.replaceWithAlternative') )) == null ? '' : __t) +
'">\n            <i class="mdi-content-reply" style="transform: scaleX(-1);"></i>\n        </button>\n        <div class="action-loading" style="display:none;">\n            <i class="mdi-action-autorenew icon-spin"></i>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

